<div class="contacts-search">
  <form [formGroup]="form">
    <div id="filters">
      <!-- https://angular.io/docs/ts/latest/guide/template-syntax.html#!#binding-syntax -->
      <mat-form-field class="flex">
        <input
          matInput
          type="text"
          placeholder="Search..."
          [formControl]="keywords" />
      </mat-form-field>
    </div>
  </form>
</div>
<div class="contacts-list">
  <mat-nav-list>
    @for (person of requestors; track person; let i = $index) {
      <mat-list-item class="mat-2-line" [routerLink]="[person.Id]">
        <h3 matListItemLine>
          {{ person.LastFirst
          }}{{ person.Alias ? ', AKA "' + person.Alias + '""' : '' }}
        </h3>
        <p matListItemLine>{{ person.OrgSummary }}</p>
      </mat-list-item>
    }
    <!--<mat-divider mat-inset hide-sm *ngIf="!$last"></mat-divider>-->
    <!--<mat-divider hide-gt-sm *ngIf="!$last"></mat-divider>-->
  </mat-nav-list>
</div>
